import { computed, toValue } from 'vue';
import { useMutation, useQuery } from '@tanstack/vue-query';

import http from '@/services/http';
import { queryKeys } from '@/queries/_shared/queryKeys';

function normalizeList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.body)) return data.body;
  return [];
}

async function fetchPushTokenState(token, userId) {
  const response = await http.get('/users/push-tokens', {
    headers: {
      'cache-control': 'no-cache',
      'x-loaded-from': 'no-cache'
    },
    params: {
      token: String(token || ''),
      user_id: Number(userId || 0)
    }
  });
  return normalizeList(response.data);
}

async function registerPushToken({ token, userId, type = 4 }) {
  const response = await http.post('/users/push-tokens', {
    token: String(token || ''),
    user_id: Number(userId || 0),
    type: Number(type || 4)
  });
  return response.data;
}

async function deletePushToken({ token }) {
  const response = await http.delete('/users/push-tokens', {
    params: {
      id: String(token || '')
    }
  });
  return response.data;
}

export function usePushTokenStateQuery(token, userId, options = {}) {
  return useQuery({
    queryKey: computed(() => queryKeys.settings.pushTokenState(toValue(token), toValue(userId))),
    queryFn: () => fetchPushTokenState(toValue(token), toValue(userId)),
    enabled: computed(() => Boolean(toValue(token)) && Boolean(Number(toValue(userId) || 0))),
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    ...options
  });
}

export function useRegisterPushTokenMutation(options = {}) {
  return useMutation({
    mutationFn: registerPushToken,
    ...options
  });
}

export function useDeletePushTokenMutation(options = {}) {
  return useMutation({
    mutationFn: deletePushToken,
    ...options
  });
}
